import { useCallback } from 'react';
import type { AnySchema } from 'yup/lib/schema';
export const useYupValidationResolver = <T extends AnySchema<any>>(validationSchema: T) =>
  useCallback(
    async (data) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
        });

        return {
          values,
          errors: {},
        };
      } catch (errors) {
        return {
          values: {},
          errors: errors.inner.reduce(
            (allErrors: Record<string, unknown>, currentError: Record<string, string>) => ({
              ...allErrors,
              [currentError.path]: {
                type: currentError.type ?? 'validation',
                message: currentError.message,
              },
            }),
            {}
          ),
        };
      }
    },
    [validationSchema]
  );

export const isTabHasError = (errors: Record<string, unknown>, keys: string[]) => {
  const errorKeys = Object.keys(errors);
  return errorKeys.some((errorKey) => {
    const modifiedErrorKey = errorKey.replace(/\[.*$/, '');
    return keys.includes(modifiedErrorKey);
  });
};
